import * as React from 'react';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { MenuItemDto } from './FormGroups';
import { Typeahead } from 'react-bootstrap-typeahead';
import { getErrorMessage, formGroup } from './FormFunctions';

export interface AutocompleteProps {
    id?: string;
    errorMessages: ValidationError[];
    label: string;
    name: string;
    selected: MenuItemDto[];
    onChange: (name: string, value: any[]) => void;
    transformData?: (value: any[]) => any[];
    data: MenuItemDto[];
    placeholder?: string;
    clearAfterSelect?: boolean;
    multiple?: boolean;
    allowNew?: boolean | ((results: Array<string|Object>, props: Object) => boolean);
    newSelectionPrefix?: string;
    noResultLabel?: string;
    extraValidationField?: string;
}

class Autocomplete extends React.Component<AutocompleteProps, any> {
    private _typeahead: any;

    render() {

        let options: any[] = [];
        this.props.data.forEach(element => {
            let option = {
                'key': element.key,
                'value': element.value
            };
            options.push(option);
        });

        let selected: any[] = [];
        this.props.selected.forEach(element => {
            let option = {
                'key': element.key,
                'value': element.value
            };
            selected.push(option);
        });

        const clearAfterSelect = this.props.clearAfterSelect !== undefined && this.props.clearAfterSelect;
        const noResultLabel = this.props.noResultLabel ? this.props.noResultLabel : 'Intet resultat';

        let formControl = (
            <Typeahead
                id={this.props.id}
                emptyLabel={noResultLabel}
                className='typeahead-multiselect'
                name={this.props.name}
                placeholder={this.props.placeholder}
                options={options}
                selected={selected}
                labelKey='value'
                allowNew={this.props.allowNew}
                newSelectionPrefix={this.props.newSelectionPrefix}
                multiple={this.props.multiple !== undefined ? this.props.multiple : true}    
                ref={(input: any) => {
                    this._typeahead = input;
                }}
                onChange={x => {
                    if (x.length > 0) {
                        if (this.props.transformData) {
                            this.props.onChange(this.props.name, this.props.transformData(x));
                        } else {
                            this.props.onChange(this.props.name, x.map((t: any) => t['key']));
                        }
                        if (clearAfterSelect) {
                            this._typeahead.getInstance().clear();
                        }                        
                    } else if (!clearAfterSelect) {
                        this.props.onChange(this.props.name, []);
                    }
                }}
            />);
        let validationError = getErrorMessage(this.props.errorMessages, this.props.name);
        if (!validationError) {
            validationError = getErrorMessage(this.props.errorMessages, this.props.extraValidationField);
        }
        return formGroup(this.props.label, formControl, validationError);
    }
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/input/Autocomplete.tsx